import { all } from 'redux-saga/effects';
import howitworkSagas from './home/howitWork/saga';
import testimonialSagas from './home/testimonial/saga';
import whychoosecarSagas from './home/whychooseskycar/saga';
import faqsSagas from './home/faqs/saga';//Sarada : 10-10-2022
import homeofferSagas from  './home/homeoffers/saga';
import aboutinfoSagas from './home/aboutinfo/saga';
import aboutuscontentSagas from './aboutus/aboutcontent/saga';
import valuesSagas from './aboutus/values/saga';
import aboutbannerSagas from './aboutus/aboutbanner/saga';
import ourvehicleSagas from './home/ourvehicle/saga';

export default function* rootSaga() {
  yield all([
    howitworkSagas(),
    ourvehicleSagas(),
    whychoosecarSagas(),
    faqsSagas(),
    homeofferSagas(),
    aboutinfoSagas(),
    testimonialSagas(),
    aboutbannerSagas(),
    aboutuscontentSagas(),
    valuesSagas()
  ]);
}
